var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-backtop',{attrs:{"target":"#app .backtop","bottom":196,"visibility-height":200}},[_c('svg-icon',{attrs:{"icon-class":"back-top"}}),_vm._v(" "),_c('p',[_vm._v("返回顶部")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13662bb3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TheBacktop.vue
// module id = null
// module chunks = 